import { AddCircleOutline } from "@mui/icons-material";
import { Button, Grid, TextField, Typography } from "@mui/material";

interface Props {
  setSearch: (value: string) => void;
  showAddForm: () => void;
}

function TemplatesTableHeader({ setSearch, showAddForm }: Props) {
  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={12} md={5}>
        <Typography variant="h2">Document Templates</Typography>
      </Grid>
      <Grid item xs={12} md={7} container justifyContent="flex-end" alignItems="center" flexWrap="nowrap" sx={{ gap: 2 }}>
        <TextField onChange={onSearchChange} size="small" variant="outlined" fullWidth placeholder="Search" />
        <Button onClick={showAddForm} variant="contained" endIcon={<AddCircleOutline />}>
          Add
        </Button>
      </Grid>
    </Grid>
  );
}

export default TemplatesTableHeader;
